export default __webpack_public_path__ + "static/media/emptyTable.adf2f58a.svg";